import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
    FaClipboardCheck,
    FaUsers,
    FaFileInvoice,
    FaSignOutAlt,
    FaBars,
    FaHome,
    FaCreditCard,
    FaHistory,
    FaClock,
    FaClipboardList,
} from "react-icons/fa";
import { useState, useEffect } from "react";
import "./Sidebar.css";
import logo from "../asset/feezaap-logo.png"
import pkg from "../../package.json";

const Sidebar = ({ isOpen, onClose }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname.includes('/enquiry')) {
            setCollapsed(true);
        } else {
            setCollapsed(false);
        }
    }, [location.pathname]);

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const isParent = user.roleName === "PARENT";

    const handleLogout = () => {
        localStorage.clear();
        navigate("/", { replace: true });
    };

    const triggerLogout = () => {
        setShowLogoutConfirm(true);
    };

    return (
        <div className={`sidebar ${collapsed ? "collapsed" : ""} ${isOpen ? "mobile-open" : ""}`}>
            {/* Header */}
            <div className="sidebar-header">
                <div className="brand-wrap">
                    <img src={logo} alt="Logo" className="sidebar-logo-img" />
                    {(!collapsed || isOpen) && (
                        <h2 className="brand-text">FeeZaap</h2>
                    )}
                </div>

                <div className="header-actions">
                    <FaBars
                        className={`collapse-btn ${collapsed ? "collapsed" : ""} desktop-only`}
                        onClick={() => setCollapsed(!collapsed)}
                    />
                </div>
            </div>



            {/* Menu */}
            <nav className="sidebar-menu">

                {/* ✅ Dashboard (DEFAULT) */}
                {!isParent && (
                    <NavLink
                        to="/dashboard"
                        end
                        className={({ isActive }) =>
                            `menu-item ${isActive ? "active" : ""}`
                        }
                        onClick={() => isOpen && onClose()}
                    >
                        <div className="menu-icon"><FaHome /></div>
                        {(!collapsed || isOpen) && <span>Dashboard</span>}
                    </NavLink>
                )}





                {!isParent && (
                    <>
                        <NavLink
                            to="/dashboard/enquiry"
                            className={({ isActive }) =>
                                `menu-item ${isActive ? "active" : ""}`
                            }
                            onClick={() => isOpen && onClose()}
                        >
                            <div className="menu-icon"><FaClipboardList /></div>
                            {(!collapsed || isOpen) && <span>Enquiry</span>}
                        </NavLink>

                        <NavLink
                            to="/dashboard/students"
                            className={({ isActive }) =>
                                `menu-item ${isActive ? "active" : ""}`
                            }
                            onClick={() => isOpen && onClose()}
                        >
                            <div className="menu-icon"><FaUsers /></div>
                            {(!collapsed || isOpen) && <span>Student Master</span>}
                        </NavLink>

                        <NavLink
                            to="/dashboard/list"
                            className={({ isActive }) =>
                                `menu-item ${isActive ? "active" : ""}`
                            }
                            onClick={() => isOpen && onClose()}
                        >
                            <div className="menu-icon"><FaClipboardCheck /></div>
                            {(!collapsed || isOpen) && <span>Configurations</span>}
                        </NavLink>

                        <NavLink
                            to="/dashboard/invoice-report"
                            className={({ isActive }) =>
                                `menu-item ${isActive ? "active" : ""}`
                            }
                            onClick={() => isOpen && onClose()}
                        >
                            <div className="menu-icon"><FaFileInvoice /></div>
                            {(!collapsed || isOpen) && <span>Invoice Report</span>}
                        </NavLink>

                        <NavLink
                            to="/dashboard/pending-approval"
                            className={({ isActive }) =>
                                `menu-item ${isActive ? "active" : ""}`
                            }
                            onClick={() => isOpen && onClose()}
                        >
                            <div className="menu-icon"><FaClock /></div>
                            {(!collapsed || isOpen) && <span>Pending Approvals</span>}
                        </NavLink>
                    </>
                )}

                {isParent && (
                    <>
                        <NavLink
                            to="/dashboard/fees"
                            className={({ isActive }) =>
                                `menu-item ${isActive ? "active" : ""}`
                            }
                            onClick={() => isOpen && onClose()}
                        >
                            <div className="menu-icon"><FaCreditCard /></div>
                            {(!collapsed || isOpen) && <span>Fees</span>}
                        </NavLink>
                        
                        <NavLink
                            to="/dashboard/payment-history"
                            className={({ isActive }) =>
                                `menu-item ${isActive ? "active" : ""}`
                            }
                            onClick={() => isOpen && onClose()}
                        >
                            <div className="menu-icon"><FaHistory /></div>
                            {(!collapsed || isOpen) && <span>Payment History</span>}
                        </NavLink>
                    </>
                )}

                <NavLink
                    to="/dashboard/attendance" 
                    className={({ isActive }) =>
                        `menu-item ${isActive ? "active" : ""}`
                    }
                    onClick={() => isOpen && onClose()}
                >
                    <div className="menu-icon"><FaClipboardCheck /></div>
                    {(!collapsed || isOpen) && <span>Attendance</span>}
                </NavLink>

                {/* <NavLink to="/dashboard/invoice-report" className="menu-item">
                    <FaFileInvoice />
                    {!collapsed && <span>Invoice Report</span>}
                </NavLink>


                <NavLink to="/dashboard/manage-students" className="menu-item">
                    <FaUserGraduate />
                    {!collapsed && <span>Manage Students</span>}
                </NavLink> */}

                {/* <NavLink to="/dashboard/manage-staffs" className="menu-item">
                    <FaUsers />
                    {!collapsed && <span>Manage Staffs</span>}
                </NavLink> */}


                {/* <NavLink to="/dashboard/batch-student-report" className="menu-item">
                    <FaLayerGroup />
                    {!collapsed && <span>Batch Student Report</span>}
                </NavLink> */}

                {/* <NavLink to="/dashboard/admin-config" className="menu-item">
                    <FaFileInvoice />
                    {!collapsed && <span>Admin Config</span>}
                </NavLink> */}

            </nav>

            {/* Sidebar Footer */}
            <div className="sidebar-footer">
                {/* Logout */}
                <div className="sidebar-logout" onClick={triggerLogout}>
                    <div className="menu-icon logout-icon"><FaSignOutAlt /></div>
                    {(!collapsed || isOpen) && <span>Logout</span>}
                </div>

                {/* Version Info */}
                <div className="sidebar-version">
                    {(!collapsed || isOpen) ? `v${pkg.version}` : pkg.version}
                </div>
            </div>

            {/* Logout Confirmation Modal */}
            {showLogoutConfirm && (
                <div className="logout-overlay">
                    <div className="logout-modal">
                        <div className="logout-modal-header">
                            <FaSignOutAlt className="modal-icon" />
                            <h3>Confirm Logout</h3>
                        </div>
                        <p>Are you sure you want to log out of FeeZaap?</p>
                        <div className="modal-actions">
                            <button className="btn-cancel" onClick={() => setShowLogoutConfirm(false)}>
                                Cancel
                            </button>
                            <button className="btn-confirm" onClick={handleLogout}>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Sidebar;
